/* tslint:disable */

export class PixiConfiguration {

  public  pixieConfig: any = {
    baseUrl: '/assets/js-libs/pixie',
    crossOrigin: true,
    languages: {
      active: 'default',
      custom: {
        french: {
          filter: "filtre",
          resize: "redimensionnement",
          crop: "rognage",
          transform: "transformation",
          draw: "dessin",
          text: "texte",
          shapes: "formes",
          stickers: "autocollants",
          frame: "cadre",
          corners: "coins",
          "History": "Historique",
          "Objects": "Objets",
          "Canvas Background": "Arrière-plan du canevas",
          "Width": "Largeur",
          "Height": "Hauteur",
          "Brush Color": "Couleur du pinceau",
          "Brush Type": "Type de pinceau",
          "Brush Size": "Taille du pinceau",
          "Cancel": "Annuler",
          "Close": "Fermer",
          "Apply": "Appliquer",
          "Size": "Taille",
          "Maintain Aspect Ratio": "Conserver les proportions",
          "Use Percentages": "Utiliser les pourcentages",
          "Radius": "Rayon",
          "Align Text": "Aligner le texte",
          "Format Text": "Mettre le texte en forme",
          "Color Picker": "Sélecteur de couleurs",
          "Add Text": "Ajouter du texte",
          "Font": "Police",
          "Upload": "Charger",
          "Google Fonts": "Polices de Google",
          "Search...": "Recherche...",
          "Shadow": "Ombre",
          "Color": "Couleur",
          "Outline": "Contour",
          "Background": "Arrière-plan",
          "Texture": "Texture",
          "Gradient": "Gradué",
          "Text Style": "Style du texte",
          "Delete": "Supprimer",
          "Background Color": "Couleur d’arrière-plan",
          "Outline Width": "Largeur du contour",
          "Blur": "Flou",
          "Offset X": "Décalage X",
          "Offset Y": "Décalage Y",
          "Open": "Ouvrir",
          "Save": "Enregistrer",
          "Zoom": "Zoom",
          "Editor": "Éditeur",
          "Initial": "Initial",
          "shape": "forme",
          "sticker": "autocollant",
          "main Image": "Image principale",
          "corner": "coin",
          "opacity": "opacité",
          "drawing": "dessin",
          "applied: opacity": "appliqué: opacité",
          "applied: shadow": "appliqué: ombre",
          "applied: color": "appliqué: couleur",
          "applied: outline": "appliqué: contour",
          "applied: background": "appliqué: arrière-plan",
          "applied: texture": "appliqué: texture",
          "applied: gradient": "appliqué: gradué",
          "applied: filter": "appliqué : filtre",
          "applied: resize": "appliqué : redimensionnement",
          "applied: crop": "appliqué : rognage",
          "applied: transform": "appliqué : transformation",
          "applied: separator": "appliqué : séparateur",
          "applied: draw": "appliqué : dessin",
          "applied: text": "appliqué : texte",
          "applied: shapes": "appliqué : formes",
          "applied: stickers": "appliqué : autocollants",
          "applied: frame": "appliqué : cadre",
          "applied: corners": "appliqué : coin",
          "circle": "cercle",
          "rectangle": "rectangle",
          "triangle": "triangle",
          "ellipse": "ellipse",
          "Arrow #1": "Flèche n°1",
          "Arrow #2": "Flèche n°2",
          "Arrow #3": "Flèche n°3",
          "Line": "Ligne",
          "Star": "Étoile",
          "Polygon": "Polygone",
          "Badge": "Badge",
          "deleted: shape": "Supprimé: forme",
          "deleted: opacity": "Supprimé: opacité",
          "deleted: shadow": "Supprimé: ombre",
          "deleted: color": "Supprimé: couleur",
          "deleted: outline": "Supprimé: contour",
          "deleted: background": "Supprimé: arrière-plan",
          "deleted: texture": "Supprimé: texture",
          "deleted: gradient": "Supprimé: dégradé",
          "deleted: filter": "Supprimé: filtre",
          "deleted: resize": "Supprimé: redimensionnement",
          "deleted: crop": "Supprimé: rognage",
          "deleted: transform": "Supprimé: transformation",
          "deleted: separator": "Supprimé: séparateur",
          "deleted: draw": "Supprimé: dessin",
          "deleted: text": "Supprimé: texte",
          "deleted: shapes": "Supprimé: formes",
          "deleted: stickers": "Supprimé: autocollants",
          "deleted: frame": "Supprimé: cadre",
          "deleted: corners": "Supprimé: coins",
          "deleted: color Controls": "Supprimé Contrôles de couleur",
          "applied: color Controls": "Appliqué : Contrôles de couleur",
          "Duplicate": "Dupliquer",
          "Flip": "Faire pivoter",
          "Bring to front": "Mettre au premier plan",
          "Customize": "Personnaliser"

        }
      }
    },
    ui: {
      mode: 'overlay',
      openImageDialog: { show: false },
      toolbar: {
        hideOpenButton: true,
        hideCloseButton: false,
      },
      nav: {
        position: 'top',
        replaceDefault: true,
        items: [
          { name: 'filter', icon: 'filter-custom', action: 'filter' },
          { type: 'separator' },
          { name: 'resize', icon: 'resize-custom', action: 'resize' },
          { name: 'crop', icon: 'crop-custom', action: 'crop' },
          { name: 'transform', icon: 'transform-custom', action: 'transform' },
          { type: 'separator' },
          { name: 'draw', icon: 'pencil-custom', action: 'draw' },
          { name: 'text', icon: 'text-box-custom', action: 'text' },
          { name: 'shapes', icon: 'polygon-custom', action: 'shapes' },
          { name: 'stickers', icon: 'sticker-custom', action: 'stickers' },
          { name: 'frame', icon: 'frame-custom', action: 'frame' },
          { type: 'separator' },
          { name: 'corners', icon: 'rounded-corner-custom', action: 'corners' },
          { name: 'background', icon: 'background-custom', action: 'background' },
          //{ name: 'merge', icon: 'merge-custom', action: DrawerName.MERGE },
        ]
      }

    }
  }

  constructor() {
    ;
  }
}
